import apiSlice from 'renderer/shared/state/apiSlice';
import {
  CreatePaymentMethodRequest,
  CreatePaymentMethodResponse,
  CreatePaymentMethodResponseSchema,
  DeletePaymentMethodRequest,
  DeletePaymentMethodResponse,
  DeletePaymentMethodResponseSchema,
  ListPaymentMethodsRequest,
  ListPaymentMethodsResponse,
  PaymentMethodsSchema,
  UpdatePaymentMethodRequest,
  UpdatePaymentMethodResponse,
  UpdatePaymentMethodResponseSchema,
} from '../schemas/paymentMethods.schemas';

const extendedApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    listPaymentMethods: builder.query<ListPaymentMethodsResponse, any>({
      query: (category) => `/paymentMethod?category=${category}`,
      providesTags: ['PaymentMethods'],
      extraOptions: {
        responseSchema: PaymentMethodsSchema,
      },
    }),
    listPaymentMethodsByUserId: builder.query({
      query: (userId) => `/paymentMethod/${userId}`,
      providesTags: ['PaymentMethods'],
      extraOptions: {
        responseSchema: PaymentMethodsSchema,
      },
    }),
    createPaymentMethod: builder.mutation<
      CreatePaymentMethodResponse,
      CreatePaymentMethodRequest
    >({
      query: (body) => ({
        url: '/paymentMethod',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['PaymentMethods'],
      extraOptions: {
        responseSchema: CreatePaymentMethodResponseSchema,
      },
    }),
    editPaymentMethod: builder.mutation<
      UpdatePaymentMethodResponse,
      UpdatePaymentMethodRequest
    >({
      query: (body) => ({
        url: '/paymentMethod',
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['PaymentMethods'],
      extraOptions: {
        responseSchema: UpdatePaymentMethodResponseSchema,
      },
    }),
    // makePaymentMethodDefault: builder.mutation<
    //   UpdatePaymentMethodResponse,
    //   string
    // >({
    //   query: (id) => ({
    //     url: '/paymentMethod',
    //     method: 'PUT',
    //     body: { id, payload: { default: true } },
    //   }),
    //   invalidatesTags: ['PaymentMethods'],
    //   extraOptions: {
    //     responseSchema: UpdatePaymentMethodResponseSchema,
    //   },
    // }),
    deletePaymentMethod: builder.mutation<
      DeletePaymentMethodResponse,
      DeletePaymentMethodRequest
    >({
      query: (id) => ({
        url: `/paymentMethod/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['PaymentMethods'],
      extraOptions: {
        responseSchema: DeletePaymentMethodResponseSchema,
      },
    }),
  }),
});

export const {
  useListPaymentMethodsQuery,
  useListPaymentMethodsByUserIdQuery,
  useCreatePaymentMethodMutation,
  useEditPaymentMethodMutation,
  useDeletePaymentMethodMutation,
} = extendedApi;
